import React from 'react';
import { CheckCircle, X } from 'phosphor-react';

/**
 * Component to render correct answer section for Sequencing
 */
// changed by Cursor: added dark: variants for all hardcoded colors
export function SequencingCorrectAnswer({ allCorrectAnswerTexts }) {
  return (
    <div className="mb-6">
      <h4 className="text-sm font-semibold text-gray-700 dark:text-slate-300 mb-3">
        {allCorrectAnswerTexts.length > 1 ? 'Correct Answers:' : 'Correct Answer:'}
      </h4>
      <div className="space-y-3">
        {allCorrectAnswerTexts.length > 0 ? (
          allCorrectAnswerTexts.map((sequenceTexts, seqIdx) => (
            <div key={seqIdx} className="p-4 bg-green-50 dark:bg-green-900/20 rounded-lg border border-green-200 dark:border-green-700">
              {allCorrectAnswerTexts.length > 1 && (
                <div className="text-xs font-semibold text-green-700 dark:text-green-400 mb-2">
                  Option {seqIdx + 1}:
                </div>
              )}
              <div className="flex flex-wrap gap-2">
                {sequenceTexts.map((word, idx) => (
                  <div key={idx}>
                    <div className="px-3 py-2 rounded-full border border-green-300 dark:border-green-600 bg-white dark:bg-slate-800 shadow-sm">
                      <span className="text-sm font-medium text-green-800 dark:text-green-300">{word}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))
        ) : (
          <div className="p-4 bg-gray-50 dark:bg-slate-900 rounded-lg border border-gray-200 dark:border-slate-700">
            <span className="text-gray-500 dark:text-slate-400 text-sm italic">No correct answer available</span>
          </div>
        )}
      </div>
    </div>
  );
}

/**
 * Component to render user answer section for Sequencing
 */
// changed by Cursor: added dark: variants for all hardcoded colors
export function SequencingUserAnswer({ 
  userAnswerTexts, 
  isAnswerCorrect, 
  userAnswerIndices, 
  correctAnswerIndices 
}) {
  return (
    <div className="mb-6">
      <h4 className="text-sm font-semibold text-gray-700 dark:text-slate-300 mb-3">Your Answer:</h4>
      <div className="p-4 bg-gray-50 dark:bg-slate-900 rounded-lg border border-gray-200 dark:border-slate-700">
        {userAnswerTexts.length > 0 ? (
          <div className="flex flex-wrap gap-2">
            {userAnswerTexts.map((word, idx) => {
              const isPositionCorrect = isAnswerCorrect 
                ? true
                : correctAnswerIndices.some(correctSeq => {
                    return correctSeq[idx] !== undefined && 
                           Number(userAnswerIndices[idx]) === Number(correctSeq[idx]);
                  });
              
              return (
                <div key={idx}>
                  <div className={`px-3 py-2 rounded-full border shadow-sm ${
                    isPositionCorrect 
                      ? 'bg-green-100 dark:bg-green-900/30 border-green-300 dark:border-green-600' 
                      : 'bg-red-100 dark:bg-red-900/30 border-red-300 dark:border-red-600'
                  }`}>
                    <div className="flex items-center gap-1">
                      <span className={`text-sm font-medium ${
                        isPositionCorrect ? 'text-green-800 dark:text-green-300' : 'text-red-800 dark:text-red-300'
                      }`}>
                        {word}
                      </span>
                      {isPositionCorrect ? (
                        <CheckCircle size={14} weight="fill" color="#10b981" />
                      ) : (
                        <X size={14} weight="fill" color="#ef4444" />
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <span className="text-gray-500 dark:text-slate-400 text-sm italic">No answer provided</span>
        )}
      </div>
    </div>
  );
}

